import React from "react";

const CardFeature = (props) => {
  const { title, description, icone } = props.feature;
  return (
    <div className="flex flex-col grow items-start pt-8 pr-20 pb-12 pl-8  bg-white rounded-3xl shadow-lg">
      <img
        loading="lazy"
        src={icone}
        className="w-[62px]"
        alt="icone feature"
      />
      <div className="mt-6 md:text-xl text-lg font-bold text-black">
        {title}
      </div>
      <div className="mt-8 text-sm text-gray-600 md:w-[272px] w-[222px] ">
        {description}
      </div>
    </div>
  );
};

export default CardFeature;
